import { IApplication } from "../applications";

export interface IProfile {
  id: number;
  key: string;
  title: string;
  isDefault: boolean;
  application?: IApplication
}

export interface ICreateProfileRequest {
  key: string;
  title: string;
  isDefault: boolean;
}

export interface IUpdateProfileRequest {
  id: number;
  key: string;
  title: string;
  isDefault: boolean;
}
